import React from 'react';

import { makeStyles } from '@material-ui/core/styles';
import { topLabelHeigh } from './calloutRequestedData';
import ICalloutRequestedStep from './types/ICalloutRequestedStep';
import { preapreTimeAgo } from './calloutRequestedHelpers';


interface StepTopLabelProps {
    step: ICalloutRequestedStep
};

const useStyles =  makeStyles(() => ({
    toplabelBlock:{
        color: 'white',
        fontSize: 21,
        fontWeight: 700,
        fontFamily: 'lato',
        lineHeight:'normal',
        opacity:'0.7',
        height: topLabelHeigh
    },
}));


const StepTopLabel: React.FC<StepTopLabelProps> = ({step}) => {
    const classes = useStyles();
    const timer = React.useRef<any>(null);
    const [timeAgo, setTimeAgo] = React.useState('');

    React.useEffect(() => {
        setTimeAgo(step.timeAgo??'');
        timer.current = setInterval(() => {
            setTimeAgo(preapreTimeAgo(step.createdOn??''))
        }, 1000);
        return () => {
          clearInterval(timer.current);
        };
      }, [step])


    return (
        <div className={classes.toplabelBlock}>
        <div>
            {timeAgo??''}
        </div>
        <div>
        {(timeAgo)?'ago': ''}
        </div>
    </div>
    );
}

export default StepTopLabel;